"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PDFReportMaker = exports.ReportType = void 0;
var tslib_1 = require("tslib");
var pdfmake_1 = tslib_1.__importDefault(require("pdfmake/build/pdfmake"));
var vfs_fonts_1 = tslib_1.__importDefault(require("pdfmake/build/vfs_fonts"));
var Report_1 = require("./reportTypes/Report");
var ReportCompositePhoto_1 = require("./reportTypes/ReportCompositePhoto");
var ReportCompositePhotoOnly_1 = require("./reportTypes/ReportCompositePhotoOnly");
var ReportPhoto_1 = require("./reportTypes/ReportPhoto");
var ReportShort_1 = require("./reportTypes/ReportShort");
pdfmake_1.default.vfs = vfs_fonts_1.default.vfs;
var ReportType;
(function (ReportType) {
    ReportType["Report"] = "Report";
    ReportType["ReportShort"] = "ReportShort";
    ReportType["ReportCompositePhoto"] = "ReportCompositePhoto";
    ReportType["ReportCompositePhotoOnly"] = "ReportCompositePhotoOnly";
    ReportType["ReportPhoto"] = "ReportPhoto";
})(ReportType || (exports.ReportType = ReportType = {}));
var PDFReportMaker = /** @class */ (function () {
    function PDFReportMaker() {
    }
    PDFReportMaker.makeReport = function (type, poles) {
        var reportInstance;
        switch (type) {
            case ReportType.Report:
                reportInstance = new Report_1.Report(poles);
                break;
            case ReportType.ReportShort:
                reportInstance = new ReportShort_1.ReportShort(poles);
                break;
            case ReportType.ReportCompositePhoto:
                reportInstance = new ReportCompositePhoto_1.ReportCompositePhoto(poles);
                break;
            case ReportType.ReportCompositePhotoOnly:
                reportInstance = new ReportCompositePhotoOnly_1.ReportCompositePhotoOnly(poles);
                break;
            case ReportType.ReportPhoto:
                reportInstance = new ReportPhoto_1.ReportPhoto(poles);
                break;
            default:
                reportInstance = new Report_1.Report(poles);
        }
        return pdfmake_1.default.createPdf(reportInstance.export());
    };
    return PDFReportMaker;
}());
exports.PDFReportMaker = PDFReportMaker;
//# sourceMappingURL=ReportMaker.js.map